import { List, styled } from '@mui/material'

const DownloadList = styled(List)(() => ({
  border: '1px solid lightGray',
  borderBottom: 'none',
  borderRadius: 5,
  paddingTop: 0,
  paddingBottom: 0,
}))

export default DownloadList
